@if (form) {
  <div class="row">
    <div class="col-12">
      <p><span [innerHTML]="form.question_name"></span> @if (form.question_required) {
        <span class="required">*</span>
      }</p>
      @if (!form.view) {
        <!-- input จริงถูกซ่อน เปิดด้วยการคลิก dropzone -->
        <input #fileInput type="file"
          accept="image/png,image/jpeg,image/gif,image/webp,.pdf,.doc,.docx,.xls,.xlsx"
          hidden (change)="onSelect($event)" />
        <div class="dropzone" [class.disabled]="uploading" (click)="!uploading && fileInput.click()">
          @if (!uploading) {
            <i class="pi pi-cloud-upload up-icon"></i>
            <p class="up-title">คลิกเพื่อเลือกไฟล์</p>
            <p class="up-hint">jpg, png, gif, webp, pdf, doc, docx, xls, xlsx · ไม่เกิน 5MB</p>
          }
          @if (uploading) {
            <i class="pi pi-spin pi-spinner up-icon"></i>
            <p class="up-title">กำลังอัปโหลด...</p>
          }
        </div>
        @if (error) {
          <small class="d-block err">{{error}}</small>
        }
      }
      @if (form.answer_value && isImageAnswer) {
        <div class="mt-3 preview">
          <img [src]="previewUrl" alt="uploaded" />
          @if (!form.view) {
            <i class="pi pi-times remove" (click)="removeFile()" title="ลบรูป"></i>
          }
        </div>
      }
      <!-- เอกสาร (pdf/doc/docx/xls/xlsx) ถูกห่อเป็น .zip เสมอ — โชว์เป็นลิงก์ดาวน์โหลดพร้อมชื่อไฟล์เดิม แทนที่จะพยายามแสดงเป็นรูป -->
      @if (form.answer_value && !isImageAnswer) {
        <div class="mt-3 file-preview">
          <a [href]="previewUrl" target="_blank" rel="noopener" class="file-preview-link">
            <i class="pi pi-file"></i>
            <span class="file-preview-name">{{ originalName }}.zip</span>
          </a>
          @if (!form.view) {
            <i class="pi pi-times remove" (click)="removeFile()" title="ลบไฟล์"></i>
          }
        </div>
      }
    </div>
  </div>
}
